import { render } from "./EditActivityClosure.vue?vue&type=template&id=46bbf905"
import script from "./EditActivityClosure.vue?vue&type=script&lang=js"
export * from "./EditActivityClosure.vue?vue&type=script&lang=js"

import "./EditActivityClosure.vue?vue&type=style&index=0&id=46bbf905&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__